import { useContext } from 'react';

import { Button } from '@/components/ui/button';
import { useTabLabels } from '@/hooks/useTabLabels';

import CourseEditContext from '../CourseEditContext';

interface CourseButtonGroupProps {
	courseFocusId: string;
	inputFocusRef: { current: boolean };
}

const CourseButtonGroup = ({ courseFocusId, inputFocusRef }: CourseButtonGroupProps) => {
	const { addSkill, canEdit, isApprovalMode } = useContext(CourseEditContext);
	const labels = useTabLabels();

	const setNewFocus = (id: string, type: string) => {
		addSkill(id, type);
		inputFocusRef.current = true;
	};

	return (
		<div className="actions">
			{canEdit && !isApprovalMode && (
				<Button
					variant="secondary"
					className="mr-4 mb-2"
					onClick={() => setNewFocus(courseFocusId, 'topic')}
					size="small"
					type="button"
				>
					Add {labels.topic}
				</Button>
			)}
			{canEdit && !isApprovalMode && (
				<Button
					variant="secondary"
					className="mr-4 mb-2"
					onClick={() => setNewFocus(courseFocusId, 'question')}
					size="small"
					type="button"
				>
					Add {labels.question}
				</Button>
			)}
			{canEdit && !isApprovalMode && (
				<Button
					variant="secondary"
					className="mr-4 mb-2"
					onClick={() => setNewFocus(courseFocusId, 'skill')}
					size="small"
					type="button"
				>
					Add {labels.skill}
				</Button>
			)}
		</div>
	);
};

export default CourseButtonGroup;
